import { render, staticRenderFns } from "./EmptyScriptList.vue?vue&type=template&id=7b96b133&scoped=true&"
import script from "./EmptyScriptList.vue?vue&type=script&lang=js&"
export * from "./EmptyScriptList.vue?vue&type=script&lang=js&"
import style0 from "./EmptyScriptList.vue?vue&type=style&index=0&id=7b96b133&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b96b133",
  null
  
)

export default component.exports